import { Theme, Typography } from '@mui/material'
import TooltipMui, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import useEmotionStyles from 'hooks/useEmotionStyles'

const styles = (theme: Theme) => ({
  tooltipWrapper: {
    [`& .${tooltipClasses.tooltip}`]: {
      width: 350,
      background: theme.palette.common.white,
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: '2px',
      boxShadow: theme.shadows[3],
      color: theme.palette.grey[900]
    },
    [`& .${tooltipClasses.arrow}`]: {
      '&::before': {
        background: theme.palette.primary.main
      }
    }
  }
})

interface Props extends TooltipProps {
  children: React.ReactElement
  headline?: string
}

export const Tooltip = ({ children, placement, title, headline }: Props) => {
  const { tooltipWrapper } = useEmotionStyles(styles)

  return (
    <div className={tooltipWrapper}>
      <TooltipMui
        role="tooltip"
        arrow
        placement={placement}
        title={
          <>
            {headline && (
              <>
                <Typography
                  variant="subtitle1"
                  lineHeight="spacing(2)"
                  fontWeight="bold"
                >
                  {headline}
                </Typography>
                <br />
              </>
            )}
            {title}
          </>
        }
        PopperProps={{
          disablePortal: true,
          popperOptions: {
            modifiers: [
              {
                name: 'preventOverflow',
                enabled: true,
                options: {
                  altAxis: true,
                  altBoundary: false,
                  tether: true,
                  rootBoundary: 'viewport'
                }
              }
            ]
          }
        }}
      >
        <div>{children}</div>
      </TooltipMui>
    </div>
  )
}
